module.exports = function (bootstrap) {
    bootstrap.run(['$rootScope', function($rootScope) {
        $rootScope.sidebar = [];
    }]);

    bootstrap.directive('ebusSidebar', [ function () {
        return {
            replace: true,
            template: require('directives/ebusiness/sidebarNavigation.html'),
            controller: ['$scope', '$state', 'navigation', function($scope, $state, navigation) {

                $scope.navigationData = navigation.data;

                var setSidebar = function(state) {
                    var currentState =  $scope.currentState = state.current.name;
                    var headerTabs = navigation.data.headerTabs;

                    headerTabs.forEach(function(tab) {
                        tab.active = false;
                        tab.links.forEach(function(link) {
                            link.active = false;
                        });
                    });

                    for (var i = 0; i < headerTabs.length; ++i) {
                        var currentTab = headerTabs[i];

                        if (currentTab.state === $state.current.name) {
                            currentTab.active = true;
                            $scope.sidebar = currentTab.links;
                        }
                        else {
                            currentTab.active = false;
                        }
                        for (var j = 0, childTabs = currentTab.links; j < childTabs.length; ++j) {
                            var currentChild = childTabs[j];

                            if (currentChild.state === currentState) {
                                currentTab.active = true;
                                $scope.sidebar = currentTab.links;
                                currentChild.active = true;
                            }
                            else {
                                currentChild.active = false;
                            }
                        }
                    }
                };

                $scope.$watchCollection('navigationData.headerTabs', function() {
                    setSidebar($state);
                });
            }]
        };
    }]);
};
